import { register } from "async-ops";
import { callMvcApi } from "../../../../../call-web-api";
import { getDefaultOptions } from "../../../../../utils/fetch";
export const UPDATE_EXISTING_TASKS_DUE_DATE = "UPDATE_EXISTING_TASKS_DUE_DATE";

export const service = async (data) => {
  const options: object = {
    url: '/Api/UserTasks/UpdateExisingTasksDueDate',
    method: "POST",
    body: JSON.stringify(data),
    ...getDefaultOptions(),
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(UPDATE_EXISTING_TASKS_DUE_DATE, service, mock);
